import axiosInstance from 'axios';

export default axiosInstance.create({
  baseURL: 'https://api.covid19api.com/',
});
